import {
    Dialog,
    DialogContent, 
    DialogHeader,
    DialogTitle,
} from '@/components/ui/dialog'   
import { Field, FieldLabel } from '@/components/ui/field'
import { Progress } from '@/components/ui/progress'
import { TypographyXS } from '@/components/ui/typography'
import { ResearchCoverage } from '@/types/MarketResearch'

interface AddDialogProps {
    isOpen: boolean
    onClose: () => void
    researchCoverage: ResearchCoverage[]
}
 

const ResearchCoverageDialog = ({ isOpen, onClose, researchCoverage }: AddDialogProps) => {    

    return (
        <Dialog open={isOpen} onOpenChange={onClose}>
            <DialogContent className='max-w-[800px] max-h-[90%] overflow-auto'  aria-describedby={undefined}>
                <DialogHeader className=''> 
                    <DialogTitle>Percentual da cobertura por Representante</DialogTitle>
                </DialogHeader> 
                 
                {researchCoverage.map((item, index) => (
                    <div className='grid grid-flow-col grid-cols-3 border-b-2 pb-2 items-center' key={index}>
                        <TypographyXS className=" flex gap-2 col-span-2"> 
                            {item.NM_FUNCIONARIO}
                        </TypographyXS>
                        <Field className="w-full max-w-sm col-span-1">
                            <FieldLabel htmlFor="progress-upload">
                                <span>Publicado {(item.CLIENTES_PESQUISADOS)} / {(item.CLIENTES_PESQUISA)}</span>
                                <span className="ml-auto"> {((item.CLIENTES_PESQUISADOS / item.CLIENTES_PESQUISA) * 100).toFixed(2)}%</span>
                            </FieldLabel>
                            <Progress value={Number(((item.CLIENTES_PESQUISADOS / item.CLIENTES_PESQUISA) * 100).toFixed(2))} id="progress-upload" />
                        </Field>
                    </div>
                ))}

            </DialogContent>
        </Dialog>
    )
}

export default ResearchCoverageDialog
